import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { MEMBERSHIP_GROUP } from '../../../Domain/Settings/Constants/Constants';
import './CustomToggle.css';

const CustomToggle = ({
  // setGrout,
  parameters,
  nameMembershipsGroup = {},
  handleGroupMembership = () => {},
  schedulerId = false,
  modeId = false,
  setCurrentSelectMembership = () => {},
  handleUpdateSelection = () => {}
}) => {
  const [selected, setSelected] = useState(
    parseInt(parameters?.GROUP_MEMBERSHIP_DEFAULT?.value) || MEMBERSHIP_GROUP.PLATINIUM
  );

  return (
    <div className="toggle-container position-relative d-inline-flex align-items-center">
      <div
        className="position-absolute toggle-btn"
        style={{
          transform: `translateX(${
            selected === nameMembershipsGroup?.PLATINUM?.id ? '140px' : '0'
          })`
        }}
      />
      <Button
        variant="link"
        className={`position-relative flex-grow-1 border-0 text-decoration-none ${
          selected === nameMembershipsGroup?.SILVER?.id ? 'text-dark' : 'text-white'
        }`}
        style={{ zIndex: 1 }}
        onClick={() => {
          setCurrentSelectMembership((prev) => ({
            ...prev,
            groupSelected: nameMembershipsGroup?.SILVER?.id
          }));
          handleUpdateSelection(schedulerId);
          // setGrout(nameMembershipsGroup?.SILVER?.id);
          setSelected(nameMembershipsGroup?.SILVER?.id);
          handleGroupMembership(schedulerId, modeId, nameMembershipsGroup?.SILVER?.id);
        }}>
        {nameMembershipsGroup?.SILVER?.name || parameters?.SILVER_GROUP_MEMBERSHIPS?.value}
      </Button>

      <Button
        variant="link"
        className={`position-relative flex-grow-1 border-0 text-decoration-none ${
          selected === nameMembershipsGroup?.PLATINUM?.id ? 'text-dark' : 'text-white'
        }`}
        style={{ zIndex: 1 }}
        onClick={() => {
          setCurrentSelectMembership((prev) => ({
            ...prev,
            groupSelected: nameMembershipsGroup?.PLATINUM?.id
          }));
          handleUpdateSelection(schedulerId);
          // setGrout(nameMembershipsGroup?.PLATINUM?.id);
          setSelected(nameMembershipsGroup?.PLATINUM?.id);

          handleGroupMembership(schedulerId, modeId, nameMembershipsGroup?.PLATINUM?.id);
        }}>
        {nameMembershipsGroup?.PLATINUM?.name || parameters?.PLATINUM_GROUP_MEMBERSHIPS?.value}
      </Button>
    </div>
  );
};

export default CustomToggle;
